// Homepage-only owned job photography. Manufacturer and stock style photos are excluded.
export const HOME_SHARE_IMAGE = {
  "url": "https://1woodfloors.com/images/projects/red-oak-staircase-dusky-walnut-floor-eye-level-farmington-hills-mi.jpg",
  "width": 1280,
  "height": 917,
  "alt": "Red oak staircase stained to match a hand scraped Dusky Walnut floor, Farmington Hills, MI"
};

export const HOME_JOB_PHOTOS = [
  {
    "baseName": "custom-staircase-matching-walnut-flooring-farmington-hills-mi",
    "caption": "Red oak staircase stained to match a hand scraped Dusky Walnut floor, Farmington Hills, MI",
    "url": "https://1woodfloors.com/images/projects/red-oak-staircase-dusky-walnut-floor-eye-level-farmington-hills-mi.jpg"
  },
  {
    "baseName": "about-craftsman",
    "caption": "Sunlit corner with a refinished red oak floor, Livonia, MI"
  },
  {
    "baseName": "hardwood-install",
    "caption": "Dining area under drum pendants with a Michigan Plank rift and quartered walnut floor in 2 to 5 inch widths, Novi, MI"
  },
  {
    "baseName": "pallmann-spider-planetary-sander-dustless-refinishing-michigan",
    "caption": "Pallmann Spider planetary sander on a new site finished hardwood floor"
  },
  {
    "baseName": "northville-walnut-open-floor-kitchen",
    "caption": "Open kitchen with an 8 inch engineered FAS walnut floor, Northville, MI"
  },
  {
    "baseName": "dustless-refinish",
    "caption": "Freshly refinished hardwood floor in an empty room"
  },
  {
    "baseName": "subfloor-leveling",
    "caption": "Spirit level checking a concrete subfloor during leveling prep"
  },
  {
    "baseName": "product-spec-concierge",
    "caption": "Custom stair nosing and inlay detail on a dark stained hardwood landing"
  },
  {
    "baseName": "commercial-ann-arbor",
    "caption": "Commercial staircase refinished with Pallmann Magic Oil at a tech headquarters, Ann Arbor, MI"
  },
  {
    "baseName": "reclaimed-tobacco-pine-floor-kitchen-wide-howell-mi",
    "caption": "Reclaimed antique Tobacco Pine floor with original saw marks, supplied and installed by 1 Wood Floors, Howell, MI"
  },
  {
    "baseName": "1-wood-custom-line-8-inch-white-oak-plymouth-mi",
    "caption": "Kitchen with an 8 inch engineered 1 Wood Floors Custom Line white oak floor in Sand, Plymouth, MI"
  },
  {
    "baseName": "staircase-renovations-hero",
    "caption": "Catwalk view of a red oak staircase stained to match a hand scraped Dusky Walnut floor, Farmington Hills, MI"
  },
  {
    "baseName": "harbor-springs-invisible-maple-vaulted",
    "caption": "Vaulted room with a maple floor in an invisible finish, Harbor Springs, MI"
  },
  {
    "baseName": "red-oak-refinish-livonia-dining",
    "caption": "Dining room with a refinished red oak floor, Livonia, MI"
  },
  {
    "baseName": "viking-european-white-oak-birmingham-dining",
    "caption": "Dining room with a ¾ inch engineered Viking European white oak floor in Chisholm, Birmingham, MI"
  },
  {
    "baseName": "reclaimed-tobacco-pine-floor-kitchen-wide-howell-mi",
    "caption": "Living room with a 3¼ inch Michigan Plank first grade maple floor, site finished, Ann Arbor, MI",
    "url": "https://1woodfloors.com/images/projects/maple-michigan-plank-site-finished-floor-living-room-ann-arbor-mi.jpg"
  },
  {
    "baseName": "harbor-springs-maple-great-room",
    "caption": "Great room with a maple floor in an invisible finish overlooking Little Traverse Bay, Harbor Springs, MI"
  },
  {
    "baseName": "award-closeup",
    "caption": "Reclaimed barnwood floor with a Rubio Monocoat finish, Farmington Hills, MI"
  }
];

export const HOME_ORGANIZATION_ID = "https://1woodfloors.com/#organization";

export function makeHomeImageSchemas(resolveImage) {
  return HOME_JOB_PHOTOS.map(photo => {
    const url = photo.url || resolveImage(photo.baseName);
    return {
      "@context": "https://schema.org", "@type": "ImageObject",
      "@id": `https://1woodfloors.com/#photo-${photo.baseName}`,
      contentUrl: url, url, caption: photo.caption, creditText: "1 Wood Floors",
      copyrightHolder: { "@id": HOME_ORGANIZATION_ID }, creator: { "@id": HOME_ORGANIZATION_ID },
    };
  });
}

export function makeHomeWebPageSchema() {
  return {
    "@context": "https://schema.org", "@type": "WebPage", url: "https://1woodfloors.com/",
    primaryImageOfPage: { "@id": "https://1woodfloors.com/#photo-custom-staircase-matching-walnut-flooring-farmington-hills-mi" },
  };
}
